import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIComplaintsService } from '../../_services/complaints/API-complaints';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/filter';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import * as crypto from 'crypto-js';
import { APIEncryptionDecryption } from '../../_services/CommonService/API-Common-Service';
import { Router, ActivatedRoute } from '@angular/router';
import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';

@Component({
  selector: 'app-complaints-ncpr-details',
  templateUrl: './complaints-ncpr-details.component.html',
  styleUrls: ['./complaints-ncpr-details.component.css']
})
export class ComplaintsNcprDetailsComponent implements OnInit {
  complaints: any;
  //dataSource: MyDataSource | null;
  public BatchId: any;
  public ncprDetails: any;
  public ncprFilename: any;
  public uploadedBy: any;
  public reqDate: any;
  fetchedData: any;
  form1: any = {};
  dataSubject = new BehaviorSubject<any[]>([]);
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] =
  ['dcmp', 'msisdn', 'DateTimeUcc', 'TypeUcc', 'cli', 'OAPName', 'Status'];

//'Complaint_No',

  applyFilter(filterValue: string) {
    console.log('in filter');
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  GetDND_COMPLAINTS_TSP: any;

  dataSource: any;
  complaintsArray: any[];
  mobile: any;
  Virtual_MobileNo: any;
  decrypted_mob: any;
 // complaints: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private tc: APIComplaintsService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private encryDecry: APIEncryptionDecryption,
    private imp: APIImportPreferenceService,
    ) {


    this._route.params.subscribe((params) => {
      this.BatchId = params['BatchId'];
      this.ncprFilename = params['FileName'];
      this.uploadedBy = params['UploadedBy'];
      this.reqDate = params['date'];
     // this.getComplaintsNCPRDetails(this.BatchId);
    });
    // this.tc.GetDND_COMPLAINTS_TSP().subscribe({
		this.imp.getComplaintsNCPRDetails(this.BatchId)
		.subscribe(m => {
			this.complaints = m;
			console.log('this.complaints', JSON.stringify(this.complaints));
			this.complaints.map((val, i) => {
			this.dataSource = m;
			this.onChangeDataSource(m);
		})
		})
		 

    // this.imp.getComplaintsNCPRDetails(this.BatchId).subscribe({
      // next: value => {
        // console.log('ncpr details complaints', value);
        // this.dataSubject.next(value.SummaryDetail);
        // this.dataSource = new MatTableDataSource(value.SummaryDetail);
        // this.dataSource.paginator = this.paginator;
        // this.dataSource.sort = this.sort;
        // console.log('dataSource : ', this.dataSource);

      // }
    // });

  }

  ngOnInit() {
    this.mobile = this.db.get(Constants.SESSSION_STORAGE, Constants.MOBILE_NO);

    // this.dataSource = new MyDataSource(this.dataSubject);

  }
onChangeDataSource(value)
		{
		this.dataSubject.next(value);
		this.dataSource = new MatTableDataSource();
  
		this.dataSource = new MatTableDataSource(value);
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort=this.sort;
 // console.log("dataSource : ", this.dataSource);
  
      
}
/*   getPreferenceNCPRDetails(BatchId){
    this.imp.getPreferenceNCPRDetails(BatchId)
      .subscribe(t => {
        this.ncprDetails = t;
        console.log("preferencesummaryncpr :::: ", JSON.stringify(this.ncprDetails));
      });
  } */
}

export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }



}
